<input #fileInput type="file" class="hidden" multiple="multiple" (input)="uploadFiles()">
<div class="p-inputgroup">
    <textarea pInputTextarea
              placeholder="Comment"
              class="comment-entry"
              [(ngModel)]="noteEntryInput.comment">
    </textarea>
    <button pButton icon="pi pi-paperclip" (click)="fileInput.click()"></button>
</div>
<p-messages [(value)]="messages"></p-messages>
<p-table [value]="noteEntryInput.commentAttachments">
    <ng-template pTemplate="body" let-fa>
        <tr>
            <td>
                <lb-file-detail-listing [file]="fa" [siblings]="noteEntryInput.commentAttachments"></lb-file-detail-listing>
            </td>
            <td class="p-text-right">
                <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="removeFile(fa)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>